import { useEffect, useState } from "preact/hooks";
import type { Store, WidgetState } from "./state.js";

export function useWidgetState(store: Store): WidgetState {
  const [state, setState] = useState(store.state);
  useEffect(() => store.subscribe(() => setState(store.state)), [store]);
  return state;
}
